export default function MiniSign() {
  return (
    <div data-testid="mini-sign" className="text-center text-[10px] font-semibold tracking-[0.2em] text-white/80 py-5">
      FKL S.r.l.s. &nbsp;–&nbsp; fkl.official1@gmail.com &nbsp;–&nbsp; +39 327 223 9520
    </div>
  );
}
